import { render, staticRenderFns } from "./activityCell.vue?vue&type=template&id=0fc910e8&scoped=true"
import script from "./activityCell.vue?vue&type=script&lang=js"
export * from "./activityCell.vue?vue&type=script&lang=js"
import style0 from "./activityCell.vue?vue&type=style&index=0&id=0fc910e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc910e8",
  null
  
)

export default component.exports